import {
  PROJECT_HISTORY_INIT,
  PROJECT_HISTORY_REDO_REQUEST,
  PROJECT_HISTORY_ROLLBACK_TO_BACKUP_SNAPSHOT,
  PROJECT_HISTORY_SAVE_BACKUP_SNAPSHOT,
  PROJECT_HISTORY_UNDO,
  PROJECT_HISTORY_UNDO_REQUEST,
  PROJECT_HISTORY_UNDO_TO_THE_START,
} from '@store/reducers/manager/middleware/history/types'
import {
  COMMIT_PROJECT_REQUEST,
  COMMIT_PROJECT_REQUEST_PURE,
  UPDATE_UI,
} from '@storeOld/actions'

import History from './history'

export const historyMiddleware = (store) => {
  const history = new History()

  return (next) => (action) => {
    switch (action.type) {
      case PROJECT_HISTORY_INIT:
        history.resetToSnapshot(getStateForSnapshot())

        dispatch({
          type: UPDATE_UI,
          payload: {
            undo: history.isUndoAvailable(),
            redo: history.isRedoAvailable(),
          },
        })

        break
      case COMMIT_PROJECT_REQUEST:
      case COMMIT_PROJECT_REQUEST_PURE:
        next(action)

        if (action.history === false) {
          return
        }

        history.push(getStateForSnapshot())

        dispatch({
          type: UPDATE_UI,
          payload: {
            undo: history.isUndoAvailable(),
            redo: history.isRedoAvailable(),
          },
        })
        break
      case PROJECT_HISTORY_UNDO_REQUEST:
      case PROJECT_HISTORY_REDO_REQUEST: {
        const { manager } = getState()

        if (!manager.meta.access.canEdit) {
          return
        }

        action.type === PROJECT_HISTORY_UNDO_REQUEST
          ? history.undo()
          : history.redo()

        dispatch({
          type: UPDATE_UI,
          payload: {
            undo: history.isUndoAvailable(),
            redo: history.isRedoAvailable(),
          },
        })

        dispatch({
          type: COMMIT_PROJECT_REQUEST,
          payload: {
            type: PROJECT_HISTORY_UNDO,
            payload: history.getSnapshot(),
          },
          history: false,
        })

        break
      }
      case PROJECT_HISTORY_UNDO_TO_THE_START: {
        const { manager } = getState()

        if (!manager.meta.access.canEdit) {
          return
        }

        history.undoToTheStart()

        dispatch({
          type: PROJECT_HISTORY_UNDO,
          payload: history.getSnapshot(),
        })

        dispatch({
          type: UPDATE_UI,
          payload: {
            undo: history.isUndoAvailable(),
            redo: history.isRedoAvailable(),
          },
        })
        break
      }
      case PROJECT_HISTORY_SAVE_BACKUP_SNAPSHOT: {
        history.saveBackupSnapshot()
        break
      }
      case PROJECT_HISTORY_ROLLBACK_TO_BACKUP_SNAPSHOT: {
        const { manager } = getState()

        if (!manager.meta.access.canEdit) {
          return
        }

        history.rollbackToBackup()

        dispatch({
          type: PROJECT_HISTORY_UNDO,
          payload: history.getSnapshot(),
        })

        dispatch({
          type: UPDATE_UI,
          payload: {
            undo: history.isUndoAvailable(),
            redo: history.isRedoAvailable(),
          },
        })
        break
      }
      default:
        next(action)
    }
  }

  function getState() {
    return store.getState()
  }

  function getStateForSnapshot() {
    const {
      manager: { project },
      relations,
    } = store.getState()

    return {
      project,
      relations,
    }
  }

  function dispatch(action) {
    store.dispatch(action)
  }
}
